import React from 'react'

export const DetailAnnouncement = () => {
  return (
    <div>Detail</div>
  )
}
